// extracted by mini-css-extract-plugin
module.exports = {"ModalTitle":"DataModal_ModalTitle__ugkgN","ProgressBar":"DataModal_ProgressBar__3xZbU","isActive":"DataModal_isActive__1QJUs","ModalContent":"DataModal_ModalContent__1jale"};